export const GRID_BREAKPOINTS = { lg: 1200, md: 996, sm: 768, xs: 567, xxs: 0 };
